import { isApp } from "@akina/utils";
import { platform, version, arch, type } from "@tauri-apps/plugin-os";
import type { Arch, Platform, OsType } from "@tauri-apps/plugin-os";

export type OSInfo = {
  osPlatform: Platform | null;
  osVersion: string | null;
  osArch: Arch | null;
  osType: OsType | null;
};

export const getParsedOSInfo = (osInfo: OSInfo): string => {
  return osInfo.osPlatform && osInfo.osVersion
    ? `${osInfo.osType} - version ${osInfo.osVersion} - architecture ${osInfo.osArch}`
    : (osInfo.osPlatform ?? "unknown");
};

export const getOSInfo = () => {
  let osInfo: OSInfo;

  if (isApp) {
    osInfo = {
      osPlatform: platform(),
      osVersion: version(), // this is NOT the OS version (e.g Windows 11, rather the patch version. That info is not available)
      osArch: arch(),
      osType: type(),
    };
  } else {
    osInfo = {
      osPlatform: getPlatformFromUA(),
      osVersion: null,
      osArch: null,
      osType: null,
    };
  }

  return osInfo;
};

const getPlatformFromUA = () => {
  try {
    const userAgent = navigator.userAgent;
    if (/Mac|iPod|iPhone|iPad/.test(userAgent)) return "macos";
    if (/Windows/.test(userAgent)) return "windows";
    if (/Linux/.test(userAgent)) return "linux";
    return null;
  } catch {
    return null;
  }
};
